<template>
  <tr
    class="ltr:font-sans text-xs border-b border-brand-gray-300 w-full bg-white relative left-12 right-12"
  >
    <td class="py-4">
      <div class="flex items-center gap-3">
        {{ $t('DraftStatus') }}:
        <span class="text-gray-700 font-semibold">
          {{ requestDraft.draftStatus?.text }}
        </span>
      </div>
    </td>
    <td class="relative left-8 py-4">
      <div class="flex items-center gap-3">
        {{ $t('MobileNo') }}:
        <span v-html="checkOwnerMobileNo(requestDraft)"></span>
      </div>
    </td>
    <td class="relative left-8 py-4">
      <div class="flex items-center gap-3">
        {{ $t('email') }}:
        <span v-html="checkOwnerEmail(requestDraft)"></span>
      </div>
    </td>
    <td
      class="relative left-8 py-4"
      v-if="requestDraft.readyToPaymentFlag && requestDraft.request.genderId"
    >
      <div class="flex items-center gap-3">
        {{ $t('gender') }}:
        <span>{{ genderText }}</span>
      </div>
    </td>
  </tr>
</template>

<script setup>
import lookups from '@/assets/json/clientLookups.json'

const props = defineProps({
  requestDraft: {
    type: Object,
    default: () => {}
  },
  genderText: {
    type: String,
    default: () => ''
  }
})

const {
  issuePassport,
  replacePassport,
  naturalizationRequest,
  updateMobileNumber,
  femaleChildrenNaturalizationRequest,
  citizenWifeNaturalizationRequest,
  familyBookAddChild,
  familyBookAddWifeOrHusband,
  entryExit,
  reportsResidenceDetails,
  companyVisitTransferToCourtRequest,
  companyTransferToCourtRequest,
  NewBornVisaHolders,
  companyTransferTtoCourtRequest,
  refundFees,
  icaRefund,
  guardianship,
  issueNewFamilyBookDueDivorcing,
  dubaiResidentsNewService,
  dubaiResidentsRenewService,
  dubaiResidentsReplaceId,
  dubaiResidentsNewBorn,
  issueNewEmiratesIDForDiplomatic,
  renewEmiratesIDForDiplomatic,
  replaceEmiratesIDForDiplomatic,
  citizenMothersNameModification,
  citizenBirthdateModification,
  citizenAgeEstimation,
  citizenFirstNameModification,
  citizenAddingAnExistingNickname,
  maritalStatusModification
} = lookups.ServiceTransactions

const {
  issueNewIDForGccCitizen,
  renewIDForGccCitizen,
  replaceIDCardForGccCitizen,
  renewIDForCitizen,
  replaceIDCardForCitizen,
  citizensFirstTimeIssue,
  citizensNewbornRegistertion
} = lookups.eidaServices

const firstOwnerMobValidityCase = [
  issuePassport,
  replacePassport,
  naturalizationRequest,
  updateMobileNumber,
  femaleChildrenNaturalizationRequest,
  citizenWifeNaturalizationRequest,
  citizenMothersNameModification,
  citizenBirthdateModification,
  citizenAgeEstimation,
  citizenFirstNameModification,
  citizenAddingAnExistingNickname
]

const secondOwnerMobValidityCase = [
  entryExit,
  reportsResidenceDetails,
  companyVisitTransferToCourtRequest,
  companyTransferToCourtRequest,
  NewBornVisaHolders,
  companyTransferTtoCourtRequest,
  icaRefund,
  refundFees,
  guardianship,
  issueNewFamilyBookDueDivorcing,
  dubaiResidentsNewService,
  dubaiResidentsRenewService,
  dubaiResidentsReplaceId,
  dubaiResidentsNewBorn,
  issueNewEmiratesIDForDiplomatic,
  renewEmiratesIDForDiplomatic,
  replaceEmiratesIDForDiplomatic,
  issueNewIDForGccCitizen,
  renewIDForGccCitizen,
  replaceIDCardForGccCitizen,
  renewIDForCitizen,
  replaceIDCardForCitizen,
  citizensFirstTimeIssue,
  citizensNewbornRegistertion
]

const checkOwnerMobileNo = (draft) => {
  if (!draft) return
  const {
    serviceTransactionId,
    request,
    applicantMobile,
    ownerAbroadMobileNumber,
    ownerLocalMobileNumber
  } = draft
  const { localMobile } = request || {}

  let ownerMobileNo = ''

  if (firstOwnerMobValidityCase.includes(serviceTransactionId)) {
    ownerMobileNo = localMobile || applicantMobile || 'N/A'
  } else if (secondOwnerMobValidityCase.includes(serviceTransactionId)) {
    ownerMobileNo = localMobile || applicantMobile || request?.applicantMobile || 'N/A'
  } else {
    ownerMobileNo = ownerAbroadMobileNumber || ownerLocalMobileNumber || 'N/A'
  }

  return ownerMobileNo
}

const fristEmailValidityCase = [
  issuePassport,
  replacePassport,
  naturalizationRequest,
  updateMobileNumber,
  femaleChildrenNaturalizationRequest,
  citizenWifeNaturalizationRequest,
  familyBookAddChild,
  familyBookAddWifeOrHusband,
  citizenMothersNameModification,
  citizenBirthdateModification,
  citizenAgeEstimation,
  citizenFirstNameModification,
  citizenAddingAnExistingNickname,
  icaRefund,
  refundFees,
  maritalStatusModification,
  entryExit,
  reportsResidenceDetails,
  companyVisitTransferToCourtRequest,
  companyTransferToCourtRequest,
  NewBornVisaHolders,
  companyTransferTtoCourtRequest,
  guardianship,
  issueNewFamilyBookDueDivorcing
]

const secondEmailValidityCase = [
  dubaiResidentsNewService,
  dubaiResidentsRenewService,
  dubaiResidentsReplaceId,
  dubaiResidentsNewBorn,
  issueNewEmiratesIDForDiplomatic,
  renewEmiratesIDForDiplomatic,
  replaceEmiratesIDForDiplomatic,
  issueNewIDForGccCitizen,
  renewIDForGccCitizen,
  replaceIDCardForGccCitizen,
  renewIDForCitizen,
  replaceIDCardForCitizen,
  citizensFirstTimeIssue,
  citizensNewbornRegistertion
]

const checkOwnerEmail = (draft) => {
  if (!draft) return
  let ownerEmail = ''
  const { serviceTransactionId, applicantEmail, ownerEmailAddress } = draft
  if (fristEmailValidityCase.includes(serviceTransactionId)) {
    ownerEmail = applicantEmail ?? 'N/A'
  } else if (secondEmailValidityCase.includes(serviceTransactionId)) {
    ownerEmail = ownerEmailAddress ?? applicantEmail
  } else {
    ownerEmail = ownerEmailAddress ?? 'N/A'
  }
  return ownerEmail
}
</script>

<style></style>
